import {useMediaQuery} from '@mui/material';
import {useSelector} from 'react-redux';
import {resolveIsDarkTheme, selectTheme} from '../store/prefs/selectors';

export const SYSTEM_DARK_QUERY = '(prefers-color-scheme: dark)';

/**
 * The theme actually drawn: the stored choice, or the OS setting when the user
 * never made one. Live — an OS switch re-renders while no choice is stored.
 *
 * `noSsr` reads the media query on the first render instead of rendering
 * light once and flipping after an effect, which would flash a dark-mode user
 * on every load.
 */
export const useIsDarkTheme = () => {
  const preference = useSelector(selectTheme);
  const systemPrefersDark = useMediaQuery(SYSTEM_DARK_QUERY, {noSsr: true});
  return resolveIsDarkTheme(preference, systemPrefersDark);
};
